<app-header-three></app-header-three>

<div class="section">
	<div class="container bootstrap snippet">
    <div class="row">
  		<div class="col-sm-10"><h3>Profile</h3></div>
    	
    </div>
    <div class="row">
  		<div class="col-sm-3"><!--left col-->
          <div class="">
			
			<img 
			style="height:150px"
			id="profileImage"
			[src]="userImage"
			(error)="updateUrlInvalidProfile('http://ssl.gstatic.com/accounts/ui/avatar_2x.png')"
			class="avatar img-circle img-thumbnail" alt="avatar">
			
			<h6>Upload a different photo...</h6>
			<label *ngIf="!profileImageSpin" for="profileImage_input" class="center-block btn btn-sm btn-primary" 
			>Update Profile Picture</label>
			<div  *ngIf="profileImageSpin" class="category-box-icon" style="width: 7%;float: left;">
					<i class="fas fa-spinner spinner"></i>
			</div>
			<input type="file" class="d-none text-center center-block file-upload" 
			id="profileImage_input"
			(change)="uploadImage($event, 'profile')">
		  </div>
        </div>
		<!--/col-3-->
    	<div class="col-sm-9">
            <ul class="nav nav-tabs">
                <li class="active">
					<a data-toggle="tab" href="#home" (click)="changeTab('profile')"
					[ngClass]="{'selectedTab': activeTab  === 'profile' }"	
					>Profile</a>
				</li>
                <li class="active">
					<a data-toggle="tab" href="#savedAddress" (click)="changeTab('savedAddress')"
					[ngClass]="{'selectedTab': activeTab  === 'savedAddress' }"
					>Saved Address</a>
				</li>
           </ul>
   
          <div class="tab-content">
            <div class="tab-pane active" id="home">
				  <div class="alert alert-primary" role="alert" *ngIf="porfileupdatemessge!=''">
					{{porfileupdatemessge}}
				  </div>
                  <form class="form" [formGroup]="profileform"  (ngSubmit)="profileformupdate()" id="registrationForm">
                      <div class="form-group">
                          
                          <div class="col-xs-6">
                              <label for="first_name"><b>Full Name</b></label>
								<span [ngClass]="{ 'has-error': isSubmitted && formControls.fullname.errors }">
									<input type="text" formControlName="fullname" class="form-control" name="fullname" >
							  </span>
                          </div>
                      </div>
                      <div class="form-group">
                          
                          <div class="col-xs-6">
                            <label ><b>Email Address</b></label>
							
							<span [ngClass]="{ 'has-error': isSubmitted && formControls.email.errors }">
                              <input type="email" formControlName="email" class="form-control" >
							  </span>
							  <div  *ngIf="formControls.email.errors"
							  style="text-align: left;color: red;">
								<span *ngIf="formControls.email.errors.email">Email must be a valid email address</span>
							  </div>
                          </div>
                      </div>
					  
					  <div class="form-group">
                          
                          <div class="col-xs-6">
                            <label ><b>Phone number</b></label>
							
							<span [ngClass]="{ 'has-error': isSubmitted && formControls.phone_no.errors }">
                              <input type="text" formControlName="phone_no" class="form-control" placeholder="1 555 555 5555">
							  </span>
							  <div  style="text-align: left;color: red;" class="invalid-number">
								Phone number must be valid USA format i.e 1 555 555 5555
							  </div>
                          </div>
                      </div>
                      <div class="form-group">
                           <div class="col-xs-12">
							   <div  *ngIf="profileSpin" class="category-box-icon d-flex">
									<i class="fas fa-spinner spinner"></i>
								</div>
                              	<button *ngIf="!profileSpin" class="btn btn-lg btn-success btn-sm" type="submit">
								<i class="glyphicon glyphicon-ok-sign"></i> Update Profile</button>
                            </div>
                      </div>
              	</form>
              
              
              
             </div><!--/tab-pane-->
             <div class="tab-pane" id="savedAddress">
				<button class="btn btn-primary btn-sm" (click) = "addAddressModal()">Add Address</button>
                <table class="table table-striped">
					<thead>
					  <tr>
						<th>Label</th>
						<th>Address</th>
						<th>Suit/Apartment#</th>
						<th>Cross Street</th>
						<th style="width: 102px;">Action</th>
					  </tr>
					</thead>
					<tbody>
					  <tr *ngFor="let userAddress of userSavedAddress" > 
						<td>{{userAddress.type}}</td>
						<td>{{userAddress.address}}</td>
						<td>{{userAddress.apartment}}</td>
						<td>{{userAddress.street}}</td>
						<td>
						<button class="btn btn-sm btn-primary" (click)="editAddress(userAddress)">
							<i class="fas fa-edit"></i>
						</button>
						<button class="btn btn-sm btn-danger ml-2" (click)="deleteAddress(userAddress)">
						<i class="fas fa-trash-alt"></i>
						</button>
						</td>
					  </tr>
					  
					 
					</tbody>
				  </table>
             </div>
			 <!--/tab-pane-->
               
              </div>
			  <!--/tab-pane-->
          </div><!--/tab-content-->

        </div><!--/col-9-->
    </div><!--/row-->

</div>
<!-- Cart Sidebar End -->
<div class="modal fade" id="addAddressModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
	    <label class="p-2 m-2"><b>Add Address</b></label>
		<hr>
		
		<div class="row pl-4 pr-4">
			<div class="col-xl-12">
				
				<div *ngIf="userSavedAddressError!=''" class="alert alert-danger" role="alert">
				  <strong>Error..!!</strong> {{userSavedAddressError}}
				</div>
			</div>
			
			<div class="col-xl-12 form-group">
			  <label>Address*</label>
			  <input ngx-google-places-autocomplete type="text" 
				class="form-control addressgoogleauto" 
					placeholder="" value=""  autocomplete="off" 
				(onAddressChange)="handleAddressChange($event)" id="profile_address">
			</div>
			<div class="col-xl-4 ">
			  <label>City*</label>
			  <input type="hidden" class="form-control"  name="" id="profile_lat" value="">
			  <input type="hidden" class="form-control"  name="" id="profile_lng" value="">
			  <input type="text" class="form-control"  name="" id="profile_city" value="">
			</div>
			<div class="col-xl-4 ">
			  <label>State*</label>
			  <input type="text" class="form-control"  name="" id="profile_state" value="">
			</div>
			<div class="col-xl-4 ">
			  <label>Country</label>
			  <input type="text" class="form-control"  name="" id="profile_country" value="">
			</div>
			<div class="col-xl-4 mt-2">
			  <label>Postal Code</label>
			  <input type="text" class="form-control"  id="profile_postalcode" name="" >
			</div>
			<div class="col-xl-4 mt-2">
			  <label>Suite/Apartment#</label>
			  <input type="text" class="form-control"  name="" id="profile_apartment" value="">
			</div>
			<div class="col-xl-4 mt-2">
			  <label>Cross Street </label>
			  <input type="text" class="form-control"  id="profile_crossstreet" name="" >
			</div>
			<div class="col-xl-12 " *ngIf= "addAddressType!='customlable'">
			  <label>Label </label><br>
			  <button class="btn btn-outline-danger p-1 m-1" 
			  [ngClass]="{'btn-outline-danger':  addAddressType!='Home' , 'btn-danger':addAddressType === 'Home' }"
			  (click)="selectAddType('Home');"><span >Home</span></button>
			  <button class="btn btn-outline-danger p-1 m-1"
			   [ngClass]="{'btn-outline-danger':  addAddressType!='Work' , 'btn-danger':addAddressType === 'Work' }"

			  (click)="selectAddType('Work');"><span >Work</span></button>
			  <button class="btn btn-outline-danger p-1 m-1"
			   [ngClass]="{'btn-outline-danger':  addAddressType!='customlable' , 'btn-danger':addAddressType === 'customlable' }"

			  (click)="selectAddType('customlable');"><span >Add Custom Label</span></button>
			</div>
			<div class="col-xl-12 " *ngIf= "addAddressType==='customlable'">
			  <label>Label </label><br>
			  <input type="text" name="customlable" id="customlable_input">
			  <button class="btn btn-primary p-1 m-1" (click)="saveLabel('save');"><span >Save </span></button>
			  <button class="btn btn-danger p-1 m-1" (click)="saveLabel('remove');"><span >X </span></button>
	
			</div>
		</div>
		
        <div class="modal-body">
			<div  *ngIf="addAddressSpin" class="category-box-icon" style="width: 7%;float: left;">
					<i class="fas fa-spinner spinner"></i>
			</div>
          <button *ngIf="!addAddressSpin" type="button" style="box-shadow: unset;width:auto;margin-top:0px" 
		  class="btn btn-danger"  (click)="saveAddAddress()" >Save</button>
          <button type="button" style="color:white;width:auto;margin-top:0px;box-shadow: unset;background:gray" 
		  class="btn ml-2" data-dismiss="modal"  >Cancel</button>
        </div> 
      </div>
    </div>
    </div> 
<div class="modal fade" id="editAddressModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
	    <label class="p-2 m-2"><b>Update Address</b></label>
		<hr>
		
		<div class="row pl-4 pr-4">
			<div class="col-xl-12">
				
				<div *ngIf="userSavedAddressError!=''" class="alert alert-danger" role="alert">
				  <strong>Error..!!</strong> {{userSavedAddressError}}
				</div>
			</div>
			
			<div class="col-xl-12 form-group">
			  <label>Address*</label>
			  <input ngx-google-places-autocomplete type="text" 
				class="form-control addressgoogleauto" 
					placeholder="" value=""  autocomplete="off" 
				(onAddressChange)="edithandleAddressChange($event)" id="edit_profile_address">
			</div>
			<div class="col-xl-4 ">
			  <label>City*</label>
			  <input type="hidden" class="form-control"  name="" id="edit_profile_id" value="">
			  <input type="hidden" class="form-control"  name="" id="edit_profile_lat" value="">
			  <input type="hidden" class="form-control"  name="" id="edit_profile_lng" value="">
			  <input type="text" class="form-control"  name="" id="edit_profile_city" value="">
			</div>
			<div class="col-xl-4 mt-2">
			  <label>State*</label>
			  <input type="text" class="form-control"  name="" id="edit_profile_state" value="">
			</div>
			<div class="col-xl-4 mt-2">
			  <label>Country</label>
			  <input type="text" class="form-control"  name="" id="edit_profile_country" value="">
			</div>
			<div class="col-xl-4 mt-2">
			  <label>Postal Code</label>
			  <input type="text" class="form-control"  id="edit_profile_postalcode" name="" >
			</div>
			<div class="col-xl-4 mt-2">
			  <label>Suite/Apartment#</label>
			  <input type="text" class="form-control"  name="" id="edit_profile_apartment" value="">
			</div>
			<div class="col-xl-4 mt-2">
			  <label>Cross Street </label>
			  <input type="text" class="form-control"  id="edit_profile_crossstreet" name="" >
			</div>
			<div class="col-xl-12 " *ngIf= "addAddressType!='customlable'">
			  <label>Label </label><br>
			  <button class="btn btn-outline-danger p-1 m-1" 
			  [ngClass]="{'btn-outline-danger':  addAddressType!='Home' , 'btn-danger':addAddressType === 'Home' }"
			  (click)="selectAddType('Home');"><span >Home</span></button>
			  <button class="btn btn-outline-danger p-1 m-1"
			   [ngClass]="{'btn-outline-danger':  addAddressType!='Work' , 'btn-danger':addAddressType === 'Work' }"

			  (click)="selectAddType('Work');"><span >Work</span></button>
			  <button class="btn btn-outline-danger p-1 m-1"
			   [ngClass]="{'btn-outline-danger':  addAddressType!='customlable' , 'btn-danger':addAddressType === 'customlable' }"

			  (click)="selectAddType('customlable');"><span >Add Custom Label</span></button>
			</div>
			<div class="col-xl-12 " *ngIf= "addAddressType==='customlable'">
			  <label>Label </label><br>
			  <input type="text" name="edit_customlable_input" id="edit_customlable_input" [value]="edit_customlable_input">
			  <button class="btn btn-primary p-1 m-1" (click)="saveLabel('save');"><span >Save </span></button>
			  <button class="btn btn-danger p-1 m-1" (click)="saveLabel('remove');"><span >X </span></button>
	
			</div>
		</div>
		
        <div class="modal-body">
			<div  *ngIf="addAddressSpin" class="category-box-icon" style="width: 7%;float: left;">
					<i class="fas fa-spinner spinner"></i>
			</div>
          <button *ngIf="!addAddressSpin" type="button" style="box-shadow: unset;width:auto;margin-top:0px" 
		  class="btn-danger btn"  (click)="updateAddAddress()" >Update</button>
          <button type="button" style="color:white;width:auto;margin-top:0px;background: gray;
				box-shadow: unset;" 
		  class="btn ml-2" data-dismiss="modal"  >Cancel</button>
        </div>
      </div>
    </div>
    </div> 
<app-footer></app-footer>